const Page = {
    Login : 'Login',
    Dashboard : 'Dashboard',
    Header : 'Header',
    Calendar : 'Calendar',
    CalendarOverlay : 'CalendarOverlay',
    MediaHierarchy : 'Media Hierarchy',
    GrandTotals : 'Grand Totals',
    RightHandTotals : 'Right Hand Totals',
    Theme : 'Theme',
    Footer : 'Footer',
    Configurator : 'Configurator',
    TemplateList : 'Templatelist',
    List : 'List',
    Update : 'Update',
    Create : 'Create',
    RunXP : 'RunXP'
}

export { Page };